import { createFileRoute } from "@tanstack/react-router";

import UserListPage from "/src/routes/user/list/UserListPage";
import { userListSearchSchema } from "/src/routes/user/list/userListSearch";

export type { UserListSearch } from "/src/routes/user/list/userListSearch";

export const Route = createFileRoute("/_main/users")({
  validateSearch: userListSearchSchema,
  component: UserListPage,
});
